import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, filter, debounceTime } from 'rxjs/operators';

interface Event {
    type: string;
    payload?: any;
}

type EventCallback = (payload: any) => void;

@Injectable({
    providedIn: 'root'
})
export class EventService {
    private handler = new Subject<Event>();
    private eventsSubject = new Subject<{ eventName: string; data?: any }>();
    constructor() { }

    /**
     * Broadcast the event
     * @param type type of event
     * @param payload payload
     */
    broadcast(type: string, payload = {}) {
        this.handler.next({ type, payload });
    }

    on(eventName: string): Observable<any>{
        return this.eventsSubject.asObservable().pipe(
            filter(event => event.eventName === eventName),
            map(event => event.data)
        )
    }

    /**
     * Subscribe to event
     * @param type type of event
     * @param callback call back function
     */
    subscribe(type: string, callback: EventCallback): Subscription {
        return this.handler.pipe(
            filter(event => event.type === type)).pipe(
                map(event => event.payload))
            .subscribe(callback);
    }

    getEventHandler() {
        return this.handler.asObservable();
    }

}
